export default __webpack_public_path__ + "static/media/IBMPlexSans-Bold-Latin1.96eb57c1.woff2";